import React, { useRef, useState } from 'react';
import '../styles/About.css';
import videoFile from '../assets/D7.mp4';

const About = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const toggleVideo = () => {
    const video = videoRef.current;
    if (!video) return;

    if (isPlaying) {
      video.pause();
    } else {
      video.muted = false;
      video.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="about-page">
      {/* Unified Title Section */}
      <div className="about-header">
        <h1>About Dani Import & Export Co., Ltd.</h1>
      </div>

      <div className="about-container">
        {/* Left text section */}
        <div className="about-text-section">
          <div className="about-text">
            <p>
              Founded in 2024, Dani Import & Export Co., Ltd. specializes in facilitating trade between
              Chinese manufacturers and international markets, with a particular focus on Ethiopia.
              We pride ourselves on offering quality products at competitive prices, handling all aspects
              of the transaction from negotiation to delivery.
            </p>
            <p>
              With our multilingual team and extensive network of suppliers, we make importing from China
              simple, efficient, and cost-effective. Our mission is to bridge markets and create value for
              our clients worldwide.
            </p>
            <p>
              At Dani Import and Export Trading, our mission is to empower businesses by streamlining 
              cross-border trade between Ethiopia and China. We commit to integrity, excellence, and 
              innovation, ensuring our clients enjoy efficient, reliable, and transparent international 
              trade solutions that foster growth and lasting partnerships.
            </p>
            <p>
              Our expertise spans various industries, including manufacturing, technology, construction
    materials, automotive parts, and consumer goods. This broad experience allows us to tailor our
    services to meet the unique needs of each client, delivering customized solutions that ensure
    both quality and cost efficiency.
              
            </p>
          </div>
        </div>

        {/* Right video section */}
        <div className="about-video-section">
          <div className="video-wrapper">
            <video
              ref={videoRef}
              src={videoFile}
              className="about-video"
              muted
              playsInline
              loop={false}
              preload="metadata"
            />
            <button className="video-btn" onClick={toggleVideo}>
              {isPlaying ? 'Pause Video 🔇' : 'Play Video 🔊'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;